export const DEFAULT_TABLE_SETTINGS_MODEL = {
  columnsOrderModel: [] as string[],
  columnsVisibility: {} as Record<string, boolean>,
  sortingModel: [] as [],
  columnsWidth: {} as Record<string, number>,
  pinnedColumns: {} as Record<string, never>,
};
